import api from '../../../services/Api';
import { IAuditoriaAdiantamentoViagemResultado } from '../interfaces/IAuditoriaAdiantamentoViagem';

export const AuditoriaAdiantamentoViagemService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaAdiantamentoViagemResultado> {
    const response = await api.get<IAuditoriaAdiantamentoViagemResultado>('auditoria-adiantamento-viagem/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoFiscal: '',
        fundamentacaoContabil: '',
        adiantamentosPendentes: [],
        adiantamentosConciliados: [],
      }
    );
  },
};
